import createLucideIcon from '../createLucideIcon';

const Brackets = createLucideIcon('Brackets', [
  ['path', { d: 'M16 3h3v18h-3', key: '1yor1f' }],
  ['path', { d: 'M8 21H5V3h3', key: '1qrfwo' }],
]);

export default Brackets;
